module.exports = __webpack_public_path__ + "img/how-topic-img_new.3a93469d.png";